// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/modelli/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","societaId":"number","nome":"string","descrizione":"string","html":"string","css":"string","risorse":"array"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/percorso-acquirenti/modelli/:id',
    requestBody: '[FormData nome, descrizione, html, css, immagini, rimuoviImmagini]',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/percorso-acquirenti/modelli',
    requestBody: '[FormData societaId, nome, descrizione, html, css, immagini]',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/percorso-acquirenti/modelli/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/modelli?societaId',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string","descrizione":"string","updatedAt":"string","numeroCantieri":"number","risorse":"array"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/modelli/:id/file/html',
    requestBody: null,
    response: 'file HTML (attachment)'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/modelli/:id/file/css',
    requestBody: null,
    response: 'file CSS (attachment)'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/modelli/esempio/html',
    requestBody: null,
    response: 'file HTML (attachment)'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/modelli/esempio/css',
    requestBody: null,
    response: 'file CSS (attachment)'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
